import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import { lighten } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import { MuiThemeProvider } from "@material-ui/core/styles"
import App from "components/App"
import mainTheme from "./themes/main"
import { Provider, useSelector } from "react-redux"
import store from "store"
import { BrowserRouter } from "react-router-dom"
import ScrollToTop from "components/ScrollToTop"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

var viewportUnitsBuggyfill = require("viewport-units-buggyfill")
viewportUnitsBuggyfill.init()

window.deferredPrompt = null

window.addEventListener("beforeinstallprompt", e => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault()
  // Stash the event so it can be triggered later.
  window.deferredPrompt = e
})

import "./styles/base.css"
import "react-image-crop/dist/ReactCrop.css"
import update from "immutability-helper"
var Color = require("color")

const WithThemeWrapper = () => {
  const [theme, setTheme] = useState(mainTheme)

  const brandColor = useSelector(
    state => state.organization.currentOrg.brand_theme
  )
  var color = Color(brandColor)
  const isLight = color.isLight()

  useEffect(() => {
    if (brandColor && brandColor === "#001F54") {
      setTheme(
        update(theme, {
          palette: {
            primary: {
              main: {
                $set: brandColor
              },
              light: {
                $set: "#2FBBF0"
              }
            }
          },
          overrides: {
            MuiLinearProgress: {
              barColorPrimary: {
                $set: {
                  backgroundColor: "#2FBBF0"
                }
              }
            },
            MuiButton: {
              root: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["white", "!important"],
                  textTransform: ["capitalize", "!important"]
                }
              },
              outlinedPrimary: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["white", "!important"]
                }
              },
              contained: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["#fff", "!important"]
                }
              },
              containedPrimary: {
                $set: {
                  backgroundColor: "#2FBBF0",
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["#fff", "!important"],
                  "&:hover": {
                    backgroundColor: "#2FBBF0"
                  }
                }
              }
            },
            MuiIconButton: {
              root: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["#fff", "!important"]
                }
              },
              colorPrimary: {
                $set: {
                  color: ["#001F54", "!important"]
                }
              }
            },
            MuiInput: {
              underline: {
                $set: {
                  "&:after": {
                    borderBottomColor: "#2FBBF0"
                  }
                }
              }
            },
            MuiBadge: {
              badge: {
                $set: {
                  backgroundColor: "#2FBBF0"
                }
              }
            }
          }
        })
      )
    } else if (brandColor && brandColor !== "#001F54") {
      setTheme(
        update(theme, {
          palette: {
            primary: {
              main: {
                $set: brandColor
              },
              light: {
                $set: lighten(brandColor, 0.3)
              }
            }
          },
          overrides: {
            MuiLinearProgress: {
              barColorPrimary: {
                $set: {
                  backgroundColor: lighten(brandColor, 0.3)
                }
              }
            },
            MuiButton: {
              root: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["white", "!important"],
                  textTransform: ["capitalize", "!important"]
                }
              },
              outlinedPrimary: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["white", "!important"]
                }
              },
              contained: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["#fff", "!important"]
                }
              },

              containedPrimary: {
                $set: {
                  backgroundColor: lighten(brandColor, 0.3),
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["#fff", "!important"],
                  "&:hover": {
                    backgroundColor: lighten(brandColor, 0.3)
                  }
                }
              }
            },
            MuiIconButton: {
              root: {
                $set: {
                  color: isLight
                    ? ["#001F54", "!important"]
                    : ["#fff", "!important"]
                }
              },
              colorPrimary: {
                $set: {
                  color: ["#001F54", "!important"]
                }
              }
            },
            MuiTab: {
              textColorPrimary: {
                $set: {
                  color: "#001F54!important"
                }
              }
            },
            MuiInput: {
              underline: {
                $set: {
                  "&:after": {
                    borderBottomColor: lighten(brandColor, 0.3)
                  }
                }
              }
            },
            MuiBadge: {
              badge: {
                $set: {
                  backgroundColor: lighten(brandColor, 0.3)
                }
              }
            }
          }
        })
      )
    } else {
      // reset if no color
      setTheme(mainTheme)
    }
  }, [brandColor])
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MuiThemeProvider>
  )
}

const Application = (
  <Provider store={store}>
    <Elements stripe={stripePromise}>
      <BrowserRouter>
        <ScrollToTop />
        <WithThemeWrapper />
      </BrowserRouter>
    </Elements>
  </Provider>
)

ReactDOM.render(Application, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.js